module.exports = __webpack_public_path__ + "static/media/stream_trade.3df44e3a.svg";